
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more/[id]",
      function () {
        return require("private-next-pages/more/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/more/[id]"])
      });
    }
  